/**
 * Labstep
 *
 * @desc PermissionRole Form Create
 */

import { fieldName } from 'labstep-web/components/PermissionRole/Form/fields';
import { FormCreateContainer as FormCreate } from 'labstep-web/core/Form/Create';
import { PermissionRole } from 'labstep-web/models/permission-role.model';
import type React from 'react';
import type { IPermissionRoleFormCreateProps } from './types';

export const PermissionRoleFormCreate: React.FC<
  IPermissionRoleFormCreateProps
> = ({ organization, ...rest }) => (
  <FormCreate
    autoFocus
    entityName={PermissionRole.entityName}
    parentName={organization.entityName}
    parentId={organization.id}
    fields={[fieldName]}
    {...rest}
  />
);
